import { useTracking } from '@change-corgi/core/react/tracking';

export const useCtaSection = () => {
	const track = useTracking();

	return {
		actions: {
			trackSapClick: () => {
				void track('petition_guides_article_sidebar_sap_click');
			},
		},
	};
};
